"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _axios = _interopRequireDefault(require("axios"));

var _emojiFlags = _interopRequireDefault(require("emoji-flags"));

var _utils = require("../helpers/utils");

var _bind = _interopRequireDefault(require("../mixins/bind"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-language-selector="container"]',
  selector: '[js-language-selector="selector"]',
  icon: '[js-language-selector="icon"]'
};
/**
 * Export a new language selector instance.
 */

var _default = function _default() {
  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    container: document.querySelectorAll(selectors.selector) || null
  };
  /**
   * Instance globals.
   */

  var ipstack = window.vault.ipstack;
  /**
   * Initialise component bind.
   */

  var binder = (0, _bind["default"])(nodeSelectors.container);
  /**
   * Initialise component.
   */

  function init() {
    if (!isLanguageSelectorEnabled()) {
      return;
    }

    if (binder.isSet()) {
      return;
    }

    renderOptions();
    updateFlagIcon();
    setTriggerEvents();
    binder.set();
  }
  /**
   * Set listeners.
   */


  function setTriggerEvents() {
    _toConsumableArray(nodeSelectors.container).forEach(function (element) {
      (0, _utils.on)('change', element, function () {
        return onSelectChange(element);
      });
    });
  }
  /**
   * Render redirect options in language selector.
   */


  function renderOptions() {
    var template = getRedirectOptionTemplate();

    _toConsumableArray(nodeSelectors.container).forEach(function (element) {
      element.innerHTML += template;
    });
  }
  /**
   * Get available redirect options.
   */


  function getRedirectOptionTemplate() {
    return Frame.Redirects.map(function (option) {
      if (option.country_code) {
        return "\n          <option value=\"".concat(option.country_code, "\" \n            data-country-code=\"").concat(option.country_code, "\" \n            data-continent-code=\"").concat(option.continent_code, "\"\n          >\n            ").concat(option.country_code, "\n          </option>");
      }

      return "\n        <option value=\"".concat(option.continent_code, "\" \n          data-continent-code=\"").concat(option.continent_code, "\"\n        >\n          ").concat(option.continent_code, "\n        </option>");
    }).join('');
  }
  /**
   * Handle change event on language selectors.
   * @param {HTMLElement} element - Selected drop-down.
   */


  function onSelectChange(element) {
    _jsCookie["default"].set('default_language', element.value, {
      expires: 7
    });

    var payload = {
      selected: element.value
    };
    updateFlagIcon();

    if (isValidGeoIP()) {
      fetchUserGeolocation(payload);
      return;
    }

    Frame.EventBus.emit('LanguageSelector:change', payload);
  }
  /**
   * Emit user geolocation information from response.
   */


  function getUserGeolocation(response) {
    return {
      location: {
        continent: response.continent_code,
        country: response.country_code,
        name: response.country_name
      },
      currency: {
        code: response.currency.code,
        symbol: response.currency.symbol,
        name: response.currency.name
      }
    };
  }
  /**
   * Check if GeoIP service defined in theme settings.
   */


  function isValidGeoIP() {
    return typeof ipstack !== 'undefined' && ipstack !== null;
  }
  /**
   * Return Geolocation data of current user.
   * @param {payload} - default emitted data from dropdown selector.
   */


  function fetchUserGeolocation(payload) {
    _axios["default"].get("http://api.ipstack.com/check?access_key=".concat(ipstack.accessKey)).then(function (response) {
      var geoPayload = Object.assign(payload, getUserGeolocation(response.data));
      Frame.EventBus.emit('LanguageSelector:change', geoPayload);
      return response;
    })["catch"](function (err) {
      if (err.name === 'Error' && (0, _utils.getBrowser)() === 'Internet Explorer') {
        window.alert('Unfortunately your browser is not compatible with our GeoIP detection. Please use a modern browser to continue shopping in the correct location.');
      }

      throw new Error(err);
    });
  }
  /**
   * Update flag image with selected language.
   */


  function updateFlagIcon() {
    _toConsumableArray(nodeSelectors.container).forEach(function (element) {
      var selectedOption = element.options[element.selectedIndex];
      var selectedCountryCode = selectedOption.dataset.countryCode || selectedOption.dataset.continentCode;

      var flag = _emojiFlags["default"].countryCode(selectedCountryCode);

      (0, _utils.getSiblings)(element)[0].querySelector(selectors.icon).innerHTML = flag.emoji;
    });
  }
  /**
   * Check if language selector exists on DOM.
   */


  function isLanguageSelectorEnabled() {
    return nodeSelectors.container;
  }
  /**
   * Expose public interface
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;